import { get } from 'services/api';
import { API_V4_BASE_URL } from 'settings';
import { IUpsell, IShowcaseBannerUpsell } from 'interface/upsell';
import { withLoader } from 'utils/reduxLoader';
class Upsell {
  public getUpsell(courseHash: string): Promise<IUpsell> {
    return get({
      url: `/learner/course/${courseHash}/upsell`,
      baseURL: API_V4_BASE_URL,
      validateStatus: () => true,
    }).then((response) => response.data.data);
  }

  public getLessonUpsell(lessonId: number): Promise<IUpsell> {
    return get({
      url: `/learner/lessons/${lessonId}/upsell`,
      baseURL: API_V4_BASE_URL,
      validateStatus: () => true,
    }).then((response) => response.data.data);
  }

  public getShowcaseBannerUpsell(size: number = 1): Promise<IShowcaseBannerUpsell[]> {
    const request = get({
      url: '/learner/course/highlights',
      params: {
        size,
      },
      baseURL: API_V4_BASE_URL,
      validateStatus: () => true,
    });

    return withLoader(request).then((response) => response.data.data);
  }
}

export default new Upsell();
